import React, { ReactElement, useState, useEffect } from "react";
import { logout } from "../../../apis/firebase";
import { Link, useLocation } from "react-router-dom";
import Countdown from "react-countdown";

// Components
import MultiLanguage from "../multiLanguage/multiLanguage";
import Image from "../../image/image.component";

import { useDispatch, useSelector, shallowEqual } from "react-redux";
import { useTranslation } from "react-i18next";

const Header = (): ReactElement => {
  const location = useLocation();
  const [live, setIsLiveLocation] = useState(false);
  const { t } = useTranslation();

  const dispatcher = useDispatch();

  const { generalSettings, track } = useSelector(
    ({ generalSettings, track }) => ({ generalSettings, track }),
    shallowEqual
  );

  useEffect(() => {
    if (location.pathname == "/live") {
      setIsLiveLocation(true);
    } else {
      setIsLiveLocation(false);
    }
  }, [location]);

  return (
    <header id="tm__header" className="flex-shrink-0">
      <nav
        id="tm__navbar"
        className="d-flex align-items-start align-items-lg-center navbar navbar-expand-lg navbar-light fixed-top">
        <div className={`container ${live ? "container-custom" : ""}`}>
          <div className="d-flex align-items-center">
            <a className="d-flex navbar-brand" href="/">
              <Image
                title={generalSettings?.clientName}
                path={generalSettings?.clientLogo}
                height="65"
              />
            </a>

            <div className="tm__event-countdown d-flex">
              <div className="d-flex align-items-center justify-content-between justify-content-lg-start w-100">
                <label className="fw-bold">{generalSettings?.eventName}</label>
                {track?.sessions && track?.sessions.find((d) => !d.isFinished) && (
                  <Countdown
                    date={
                      new Date(
                        track?.sessions.find((d) => !d.isFinished).startTime
                          .seconds * 1000
                      )
                    }
                    renderer={({
                      days,
                      hours,
                      minutes,
                      seconds,
                      completed,
                    }) => {
                      return (
                        <>
                          <div className="tm__countdown tm__countdown-sm tm__countdown-blue">
                            {!completed && (
                              <ul className="d-flex align-items-center m-0 p-0">
                                <li>
                                  <span>{days}</span>
                                  <small>{t("TEXT_DAYS")}</small>
                                </li>
                                <li>
                                  <span>{hours}</span>
                                  <small>{t("TEXT_HOURS")}</small>
                                </li>
                                <li>
                                  <span>{minutes}</span>
                                  <small>{t("TEXT_MINUTES")}</small>
                                </li>
                                <li>
                                  <span>{seconds}</span>
                                  <small>{t("TEXT_SECONDS")}</small>
                                </li>
                              </ul>
                            )}
                            {completed && (
                              <Link
                                to="/live"
                                className="btn btn-danger mw-0 btn-blink">
                                Live
                              </Link>
                            )}
                          </div>
                        </>
                      );
                    }}>
                    <></>
                  </Countdown>
                )}
                {/* {track?.sessions &&
                  !track?.sessions.find((d) => !d.isFinished) && (
                    <div className="bg-warning d-flex align-items-center rounded-3 ms-3 py-1 px-2">
                      <i className="bi bi-emoji-frown fs-5 me-2"></i>
                      <span className="fs-7">
                        {t("LIVE_HOLDING_EVENT_FINISHED")}
                      </span>
                    </div>
                  )} */}
              </div>
            </div>
          </div>

          <div className="d-flex align-items-center">
            <div className="dropdown">
              <button
                type="button"
                className="btn fs-4 mw-0 p-2 p-lg-0"
                data-bs-toggle="dropdown"
                aria-expanded="false">
                <i className="bi bi-three-dots-vertical"></i>
              </button>
              <ul className="dropdown-menu dropdown-menu-end">
                <li>
                  <MultiLanguage list="true"></MultiLanguage>
                </li>
                <li>
                  <button
                    className="dropdown-item"
                    type="button"
                    onClick={() => {
                      logout();
                      dispatcher({ type: "USER_LOGGED_OUT" });
                    }}>
                    Logout
                  </button>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </nav>
    </header>
  );
};

export default Header;
